<template>
  <div>
    <template v-if="!loading">
      <b-row align-v="center">
        <b-col lg="4">
          <b-row align-v="center">
            <b-col cols="8" lg="12">
              <h6 class="h6-semibold-azure-uppercase">{{ current.pad(2) }}</h6>
              <h3 class="h3-semibold-black">Sei cliente SGR?</h3>
            </b-col>

            <b-col cols="4" lg="12" v-if="isMobile" class="mb-4">
              <div class="icon">
                <img src="img/icone/SGR-Icons-Energia-alternativa.svg">
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="4">

          <b-form-group
              label="Sei già cliente SGR?"
              label-for="field1"
              :state="states.gia_cliente"
          >
            <b-form-select id="field1" v-model="localOptions.user.gia_cliente"
                           :options="siNo"
                           @input="setValid($event,'gia_cliente')"
                           class="form-control form-control-gray-900"></b-form-select>
          </b-form-group>

          <b-form-group
              label="Qual'è il tuo codice cliente?"
              label-for="field3"
              :state="states.codice_cliente"
              v-if="localOptions.user.gia_cliente"
          >
            <div class="input-group mb-2">
              <b-form-input id="field3" v-model="localOptions.user.codice_cliente"
                            @input="setValid($event,'codice_cliente')"
                            placeholder="" type="text"
                            class="form-control form-control-gray-900"></b-form-input>
            </div>
          </b-form-group>

        </b-col>
        <b-col lg="3" offset-lg="1" class=" text-center lg:text-right">
          <div class="icon" v-if="!isMobile">
            <img src="img/icone/SGR-Icons-Energia-alternativa.svg">
          </div>
          <button @click="nextStep" class="button-azure-rounded mt-2 lg:mt-8 px-8">Avanti</button>
        </b-col>
      </b-row>
    </template>
  </div>

</template>

<script>
export default {
  name: 'Step-6',
  data() {
    return {
      thisStep: 6,
      localOptions: null,
      siNo: [{text: 'Seleziona un valore', value: ''}, {text: 'Sì', value: true}, {text: 'No', value: false}],
      loading: true,
      states: {},
    }
  },
  props: {
    steps: {
      type: Number,
      required: true,
    },
    current: {
      type: Number,
      default: 1,
    },
    options: {
      type: [Array, Object],
      required: true
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  created() {
    if (this.options.step < this.thisStep) this.$router.push({name: 'step-1'})
    this.$emit('setCurrent', this.thisStep)
    this.localOptions = {...this.options};
    this.loading = false;

    if(typeof this.$analytics != 'undefined') {
      this.trackFbViewContent('check-up-energetico', 'step-6');
    }
  },
  methods: {
    nextStep() {
      let that = this;
      let valid = true;
      let isCliente = that.localOptions.user.gia_cliente;
      let codiceCliente = that.localOptions.user.codice_cliente;
      that.states = {};
      if ((isCliente && codiceCliente.length < 3)) {
        that.states['codice_cliente'] = '';
        valid = false;
      }else if (isCliente && !codiceCliente) {
        that.states['codice_cliente'] = null;
        valid = false;
      }

      if (valid) this.$emit('nextStep', this.thisStep + 1, this.localOptions);
    },
    setValid(value, key) {
      this.states[key] = value === null || value === '';
    }
  },
}
</script>

<style scoped lang="scss">
</style>